import styled from "styled-components";

export default function CustomerInfoRow({ label, value, mono = false }) {
  return (
    <InfoItem>
      <span>{label}</span>
      <strong className={mono ? "mono" : ""}>
        {value || "Non renseigné"}
      </strong>
    </InfoItem>
  );
}

const InfoItem = styled.div`
  display: grid;
  gap: 0.25rem;

  span {
    font-size: 0.76rem;
    opacity: 0.62;
    font-weight: 850;
  }

  strong {
    font-size: 0.95rem;
    font-weight: 850;
    word-break: break-word;
  }

  .mono {
    font-family: monospace;
    font-size: 0.78rem;
    opacity: 0.75;
  }
`;
